import { CreateCustomFieldReply, CustomFieldCreateParams } from "@/types/customFieldTypes";
import { Client } from "./client";
import { CustomFieldDeleteRequest, CustomFieldUpdateReply, CustomFieldUpdateRequest } from "@/backend/express/controllers/customFieldController";
import { FusaReply } from "@/types/replyTypes";

export class CustomFieldController {
  private client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  public async create(data: CustomFieldCreateParams): Promise<CreateCustomFieldReply> {
    return this.client.create('/api/custom-fields', data);
  }

  public async delete(data: CustomFieldDeleteRequest): Promise<FusaReply> {
    return this.client.delete(`/api/custom-fields/${data.id}`);
  }

  public async update(data: CustomFieldUpdateRequest): Promise<CustomFieldUpdateReply> {
    return this.client.update('/api/custom-fields', data);
  }
}
